import React from 'react';
import {
  FaLinkedin,
  FaGithub,
  FaMedium,
  FaTwitter,
  FaInstagram,
} from 'react-icons/fa';
import { StaticQuery, graphql } from 'gatsby';
import './style.scss';

const Footer = () => (
  <StaticQuery
    query={graphql`
      query SocialQuery {
        site {
          siteMetadata {
            gatsby
            bulma
          }
        }
      }
    `}
    render={data => (
      <footer className="footer center">
        <div className="content has-text-centered">
          <article className="media center">
            <span className="icon">
              <a href="https://github.com/sjr765">
                <FaGithub size="30px" color="black" />
              </a>
            </span>
            &nbsp;
            <span className="icon">
              <a href="https://www.linkedin.com/in/sean-j-ryan">
                <FaLinkedin size="30px" color="black" />
              </a>
            </span>
            &nbsp;
            <span className="icon">
              <a href="https://www.instagram.com/sjr765/">
                <FaInstagram size="30px" color="black" />
              </a>
            </span>
            &nbsp;
            <span className="icon">
              <a href="https://medium.com/@sjr765">
                <FaMedium size="30px" color="black" />
              </a>
            </span>
            &nbsp;
            <span className="icon">
              <a href="https://twitter.com/sjr765">
                <FaTwitter size="30px" color="black" />
              </a>
            </span>
            &nbsp;
          </article>
          &nbsp;
          <p className="is-size-5">
            Built with <a href={data.site.siteMetadata.gatsby}>Gatsby</a> &{' '}
            <a href={data.site.siteMetadata.bulma}>Bulma</a>
          </p>
        </div>
      </footer>
    )}
  />
);

export default Footer;
